<nz-row [nzGutter]="12">
    <nz-col [nzXs]="24" [nzMd]="24">
        <nz-card>
            <ng-container *nzCardTitle>
                <span style="font-size: 14px; font-weight: 500;">Capabilities</span>
            </ng-container>
            <nz-spin [nzSpinning]="isLoadingCapabilities">
                <nz-empty *ngIf="!isLoadingCapabilities && visibleCapabilities.length === 0"
                    nzDescription="No capabilities found"></nz-empty>
                <nz-row *ngIf="visibleCapabilities.length > 0" [nzGutter]="8">
                    <nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8" *ngFor="let cap of visibleCapabilities">
                        <div style="display: flex; align-items: center; gap: 8px; padding: 4px 0;">
                            <label nz-checkbox [ngModel]="isChecked(cap.id)" (ngModelChange)="toggleCapability(cap.id)"
                                style="flex: 1;">
                                <nz-space [nzSize]="4">
                                    <ng-container *ngIf="getCapabilityIconConfig(cap) as iconConfig">
                                        <i nz-icon [nzType]="iconConfig.iconName" nzTheme="outline"
                                            [style.color]="iconConfig.color"></i>
                                    </ng-container>
                                    <span>{{ cap.name }}</span>
                                    <span *ngIf="cap.unit" style="color: #8c8c8c; font-size: 12px;">
                                        ({{ cap.unit }})
                                    </span>
                                </nz-space>
                            </label>
                            <button nz-button nzType="text" nzSize="small" (click)="openEditModal(cap)" nz-tooltip
                                nzTooltipTitle="Edit Properties">
                                <i nz-icon nzType="edit" nzTheme="outline"></i>
                            </button>
                        </div>
                    </nz-col>
                </nz-row>
            </nz-spin>
            <div style="margin-top: 16px; display: flex; justify-content: flex-end;">
                <button nz-button nzType="primary" [nzLoading]="isSaving" (click)="saveSelection()" nzSize="default">
                    <i nz-icon nzType="save" nzTheme="outline"></i>
                    Save
                </button>
            </div>
        </nz-card>
    </nz-col>
</nz-row>

<!-- Edit Capability Properties Modal -->
<nz-modal [(nzVisible)]="isEditModalVisible" [nzTitle]="'Edit Capability Properties'" [nzWidth]="600"
    (nzOnCancel)="handleEditCancel()" [nzFooter]="null">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="editForm" *ngIf="editingCapability">
            <nz-form-item>
                <nz-form-label nzRequired>Capability</nz-form-label>
                <nz-form-control>
                    <nz-space [nzSize]="4">
                        <ng-container *ngIf="getCapabilityIconConfig(editingCapability) as iconConfig">
                            <i nz-icon [nzType]="iconConfig.iconName" nzTheme="outline"
                                [style.color]="iconConfig.color"></i>
                        </ng-container>
                        <span style="font-weight: 600;">{{ editingCapability.name }}</span>
                    </nz-space>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Color</nz-form-label>
                <nz-form-control [nzErrorTip]="'Color is required'">
                    <nz-space [nzSize]="8">
                        <input nz-input type="color" formControlName="color" style="width: 80px; height: 32px;">
                        <input nz-input formControlName="color" placeholder="#1890ff" style="flex: 1;">
                    </nz-space>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Icon</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="icon" placeholder="e.g., thermometer, dashboard">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Unit</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="unit" placeholder="e.g., °C, %, kg">
                </nz-form-control>
            </nz-form-item>

            <nz-row [nzGutter]="16">
                <nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label>Min Value</nz-form-label>
                        <nz-form-control>
                            <nz-input-number formControlName="minValue" [nzMin]="-999999" [nzMax]="999999" [nzStep]="1"
                                style="width: 100%;"></nz-input-number>
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>
                <nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label>Max Value</nz-form-label>
                        <nz-form-control>
                            <nz-input-number formControlName="maxValue" [nzMin]="-999999" [nzMax]="999999" [nzStep]="1"
                                style="width: 100%;"></nz-input-number>
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>
                <nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label>Threshold</nz-form-label>
                        <nz-form-control>
                            <nz-input-number formControlName="threshold" [nzMin]="-999999" [nzMax]="999999" [nzStep]="1"
                                style="width: 100%;"></nz-input-number>
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>
            </nz-row>
        </form>
    </ng-container>
    <ng-container *nzModalFooter>
        <nz-space>
            <button nz-button nzType="default" (click)="handleEditCancel()">Cancel</button>
            <button nz-button nzType="primary" [nzLoading]="isSavingEdit" (click)="saveCapabilityEdit()"
                [disabled]="editForm && !editForm.valid">
                Save
            </button>
        </nz-space>
    </ng-container>
</nz-modal>